var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import _ from 'lodash';
import fetch from '@adc/fetch';
import configment from '@adc/configment';
import { constraints } from '@adc/constants';
import format from './graphFormatter';
var UnknownSeekTypeError = (function (_super) {
    __extends(UnknownSeekTypeError, _super);
    function UnknownSeekTypeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnknownSeekTypeError;
}(Error));
var SeekQueryEmptyFieldsError = (function (_super) {
    __extends(SeekQueryEmptyFieldsError, _super);
    function SeekQueryEmptyFieldsError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SeekQueryEmptyFieldsError;
}(Error));
var SeekBoundsViolationError = (function (_super) {
    __extends(SeekBoundsViolationError, _super);
    function SeekBoundsViolationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SeekBoundsViolationError;
}(Error));
function hash(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    }
    return hash.toString(16).replace('-', '');
}
var LIB_OPERATION_IDENTIFIER = 'adcSeek';
var calculateDefaultOperationName = function (seekCollection, formattedQuery) {
    var appName = '';
    try {
        appName = configment.get('APP_NAME');
    }
    catch (_a) {
    }
    return [
        _.camelCase(appName),
        LIB_OPERATION_IDENTIFIER,
        _.camelCase(seekCollection),
        hash(formattedQuery),
    ]
        .filter(Boolean)
        .join('_');
};
var GENERIC_ITERATION_COMPLETION = {
    value: undefined,
    done: true,
};
var SeekTypes;
(function (SeekTypes) {
    SeekTypes["EVENTS"] = "EVENTS";
    SeekTypes["EVENT_TEMPLATES"] = "EVENT_TEMPLATES";
    SeekTypes["GLOBAL_MEDIA"] = "GLOBAL_MEDIA";
    SeekTypes["LISTINGS"] = "LISTINGS";
    SeekTypes["ACTIVE_LISTINGS"] = "ACTIVE_LISTINGS";
    SeekTypes["MARKETING_PACKAGES"] = "MARKETING_PACKAGES";
    SeekTypes["MEDIA_PACKAGES"] = "MEDIA_PACKAGES";
    SeekTypes["MLH_SYNC_LOGS"] = "MLH_SYNC_LOGS";
    SeekTypes["MORPH_LOGS"] = "MORPH_LOGS";
    SeekTypes["PROPERTIES"] = "PROPERTIES";
    SeekTypes["VENUES"] = "VENUES";
    SeekTypes["VENUE_TEMPLATES"] = "VENUE_TEMPLATES";
    SeekTypes["AUCTIONEER_DASHBOARD_PROJECTIONS"] = "AUCTIONEER_DASHBOARD_PROJECTIONS";
    SeekTypes["ATTORNEY_DASHBOARD_PROJECTIONS"] = "ATTORNEY_DASHBOARD_PROJECTIONS";
    SeekTypes["INVITATIONS"] = "INVITATIONS";
})(SeekTypes || (SeekTypes = {}));
var seekTypesQueryLookup = new Map([
    [SeekTypes.ACTIVE_LISTINGS, 'Listing'],
]);
var defaultMarketingAttributes = {
    types: [],
    classes: [],
    resolveTags: false,
    fields: ['label'],
};
var SeekRequest = (function () {
    function SeekRequest(kind) {
        this._kind = kind;
        this._offset = 0;
        this._size = 20;
        this._sort = [];
        this._query = new AllQuery();
        this._operationName = null;
        this._fields = [];
        this._implicitAggregations = [];
        this._fieldsConfig = {
            fragmentDefinitions: {},
        };
    }
    SeekRequest.for = function (kind) {
        if (!Object.values(SeekTypes).includes(kind)) {
            throw new UnknownSeekTypeError();
        }
        return new SeekRequest(kind);
    };
    SeekRequest.prototype.size = function (s) {
        if (s > constraints.BACKEND_MAX_PAGE_SIZE) {
            throw new SeekBoundsViolationError();
        }
        this._size = s;
        return this;
    };
    SeekRequest.prototype.offset = function (o) {
        this._offset = o;
        return this;
    };
    SeekRequest.prototype.fields = function (f, c) {
        this._fields = f;
        if (c) {
            this._fieldsConfig = c;
        }
        return this;
    };
    SeekRequest.prototype.operationName = function (name) {
        this._operationName = name;
        return this;
    };
    SeekRequest.prototype.implicitAggregations = function (aggregations) {
        this._implicitAggregations = aggregations;
        return this;
    };
    SeekRequest.prototype.query = function (builder) {
        this._query = new SeekQuery();
        builder(this._query);
        return this;
    };
    SeekRequest.prototype.dsl = function (dsl) {
        this._query = {
            toObject: function () { return dsl; },
        };
        return this;
    };
    SeekRequest.prototype.marketingAttributes = function (options) {
        if (options === void 0) { options = defaultMarketingAttributes; }
        this._marketingAttributes = __assign(__assign({}, defaultMarketingAttributes), _.cloneDeep(options));
        return this;
    };
    SeekRequest.prototype.sortByField = function (field, order) {
        if (order === void 0) { order = 'DESC'; }
        this._sort.push({
            field: field,
            order: order.toUpperCase(),
        });
        return this;
    };
    SeekRequest.prototype.sortByScript = function (script, order) {
        if (order === void 0) { order = 'DESC'; }
        this._sort.push({
            script: script,
            order: order.toUpperCase(),
        });
        return this;
    };
    SeekRequest.prototype.sortByGeo = function (field, center, order) {
        if (order === void 0) { order = 'ASC'; }
        this._sort.push({
            geo_distance: {
                field: field,
                center: center,
            },
            order: order.toUpperCase(),
        });
        return this;
    };
    SeekRequest.prototype.toObject = function (includeFieldsInDsl, dangerousSizeOverride) {
        if (includeFieldsInDsl === void 0) { includeFieldsInDsl = true; }
        return __assign({ query: this._query.toObject(), size: dangerousSizeOverride !== null && dangerousSizeOverride !== void 0 ? dangerousSizeOverride : this._size, offset: this._offset, sort: this._sort }, (includeFieldsInDsl ? { fields: this._applicableFields } : {}));
    };
    SeekRequest.prototype.execute = function (opts, _a) {
        if (opts === void 0) { opts = {}; }
        var _b = _a === void 0 ? {} : _a, _c = _b.includeFieldsInDsl, includeFieldsInDsl = _c === void 0 ? false : _c, _d = _b.dangerousSizeOverride, dangerousSizeOverride = _d === void 0 ? undefined : _d;
        return fetch
            .forAuctionGraph(this.toParameterizedQuery(includeFieldsInDsl, dangerousSizeOverride), opts)
            .then(function (res) { return res.body; });
    };
    SeekRequest.prototype.iterator = function (opts, _a) {
        var _b;
        var _this = this;
        var _c = (_a === void 0 ? {} : _a).includeFieldsInDsl, includeFieldsInDsl = _c === void 0 ? false : _c;
        var _d = opts || {}, _e = _d.batchSize, batchSize = _e === void 0 ? 1 : _e, _f = _d.pageSize, pageSize = _f === void 0 ? 60 : _f;
        if (pageSize % batchSize !== 0) {
            throw new Error('Invalid batchSize and pageSize combination. Must be a divisor.');
        }
        var currentPage = 1;
        var currentPageIndex = 0;
        var currentBatchIndex = 0;
        var expectedIterationPages = 1;
        var fetchNextPage = function () {
            _this._size = pageSize;
            _this._offset = (currentPage - 1) * pageSize;
            return _this.execute({}, { includeFieldsInDsl: includeFieldsInDsl }).then(function (res) {
                if (currentPage === 1) {
                    expectedIterationPages = res.data.seek.total_pages;
                }
                return res.data.seek;
            });
        };
        var fetcherPromise = fetchNextPage();
        var iterateForNextPage = function (previousData) {
            if (currentPageIndex < previousData.content.length) {
                if (batchSize > 1) {
                    var value = [];
                    var localBatchSize = 0;
                    while (localBatchSize < batchSize &&
                        currentBatchIndex < previousData.content.length) {
                        value.push(previousData.content[currentBatchIndex]);
                        localBatchSize++, currentBatchIndex++, currentPageIndex++;
                    }
                    return { value: value, done: false };
                }
                else {
                    var value = previousData.content[currentPageIndex];
                    currentPageIndex += 1;
                    return { value: value, done: false };
                }
            }
            currentPageIndex = 0;
            currentBatchIndex = 0;
            currentPage += 1;
            if (currentPage <= expectedIterationPages) {
                fetcherPromise = fetchNextPage();
                return fetcherPromise.then(iterateForNextPage);
            }
            return GENERIC_ITERATION_COMPLETION;
        };
        var resolveRemainingPromises = function () {
            return fetcherPromise.then(iterateForNextPage);
        };
        var iteratorMethods = (_b = {},
            _b[Symbol.asyncIterator] = function () { return iteratorMethods; },
            _b.next = resolveRemainingPromises,
            _b.return = function () { return Promise.resolve(GENERIC_ITERATION_COMPLETION); },
            _b);
        return iteratorMethods;
    };
    SeekRequest.prototype.dangerouslyExecuteAll = function (_a) {
        var _b = (_a === void 0 ? {} : _a).includeFieldsInDsl, includeFieldsInDsl = _b === void 0 ? false : _b;
        var e_1, _c;
        return __awaiter(this, void 0, void 0, function () {
            var total, asyncIterator, asyncIterator_1, asyncIterator_1_1, items, e_1_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        total = [];
                        asyncIterator = this.iterator({
                            batchSize: constraints.BACKEND_MAX_PAGE_SIZE,
                            pageSize: constraints.BACKEND_MAX_PAGE_SIZE,
                        }, { includeFieldsInDsl: includeFieldsInDsl });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 12]);
                        asyncIterator_1 = __asyncValues(asyncIterator);
                        _d.label = 2;
                    case 2: return [4, asyncIterator_1.next()];
                    case 3:
                        if (!(asyncIterator_1_1 = _d.sent(), !asyncIterator_1_1.done)) return [3, 5];
                        items = asyncIterator_1_1.value;
                        total.push.apply(total, items);
                        _d.label = 4;
                    case 4: return [3, 2];
                    case 5: return [3, 12];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 12];
                    case 7:
                        _d.trys.push([7, , 10, 11]);
                        if (!(asyncIterator_1_1 && !asyncIterator_1_1.done && (_c = asyncIterator_1.return))) return [3, 9];
                        return [4, _c.call(asyncIterator_1)];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9: return [3, 11];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [7];
                    case 11: return [7];
                    case 12: return [2, Promise.resolve(total)];
                }
            });
        });
    };
    SeekRequest.prototype.batchExecute = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.onData, onData = _c === void 0 ? _.noop : _c, _d = _b.includeFieldsInDsl, includeFieldsInDsl = _d === void 0 ? false : _d, _e = _b.maxBatches, maxBatches = _e === void 0 ? undefined : _e;
        var e_2, _f;
        return __awaiter(this, void 0, void 0, function () {
            var asyncIterator, batchCount, items, asyncIterator_2, asyncIterator_2_1, e_2_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        asyncIterator = this.iterator({
                            batchSize: constraints.BACKEND_MAX_PAGE_SIZE,
                            pageSize: constraints.BACKEND_MAX_PAGE_SIZE,
                        }, { includeFieldsInDsl: includeFieldsInDsl });
                        batchCount = 0;
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 6, 7, 12]);
                        asyncIterator_2 = __asyncValues(asyncIterator);
                        _g.label = 2;
                    case 2: return [4, asyncIterator_2.next()];
                    case 3:
                        if (!(asyncIterator_2_1 = _g.sent(), !asyncIterator_2_1.done)) return [3, 5];
                        items = asyncIterator_2_1.value;
                        if (typeof maxBatches !== 'undefined') {
                            onData(items);
                            if (batchCount >= maxBatches - 1)
                                return [3, 5];
                            else
                                batchCount++;
                        }
                        else {
                            onData(items);
                        }
                        _g.label = 4;
                    case 4: return [3, 2];
                    case 5: return [3, 12];
                    case 6:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 12];
                    case 7:
                        _g.trys.push([7, , 10, 11]);
                        if (!(asyncIterator_2_1 && !asyncIterator_2_1.done && (_f = asyncIterator_2.return))) return [3, 9];
                        return [4, _f.call(asyncIterator_2)];
                    case 8:
                        _g.sent();
                        _g.label = 9;
                    case 9: return [3, 11];
                    case 10:
                        if (e_2) throw e_2.error;
                        return [7];
                    case 11: return [7];
                    case 12: return [2, Promise.resolve()];
                }
            });
        });
    };
    SeekRequest.prototype.toQuery = function (includeFieldsInDsl, dangerousSizeOverride) {
        if (includeFieldsInDsl === void 0) { includeFieldsInDsl = true; }
        return this.buildQuery(false, includeFieldsInDsl, dangerousSizeOverride);
    };
    SeekRequest.prototype.toParameterizedQuery = function (includeFieldsInDsl, dangerousSizeOverride) {
        if (includeFieldsInDsl === void 0) { includeFieldsInDsl = true; }
        return this.buildQuery(true, includeFieldsInDsl, dangerousSizeOverride);
    };
    SeekRequest.prototype.buildQuery = function (parameterized, includeFieldsInDsl, dangerousSizeOverride) {
        if (includeFieldsInDsl === void 0) { includeFieldsInDsl = true; }
        if (this._fields.length === 0) {
            throw new SeekQueryEmptyFieldsError();
        }
        var stringifiedDsl = JSON.stringify(this.toObject(includeFieldsInDsl, dangerousSizeOverride));
        var escapedDsl = JSON.stringify(stringifiedDsl);
        var typeName = seekTypesQueryLookup.get(this._kind) ||
            this._kind.slice(0, 1) +
                this._kind
                    .slice(1)
                    .toLowerCase()
                    .replace(/_([a-z]{1})/g, function (l) { return l[1].toUpperCase(); })
                    .slice(0, -1);
        var formatted = format(this._fields, this._fieldsConfig, 8);
        var operationName = this._operationName ||
            calculateDefaultOperationName(this._kind, formatted.fields);
        var implicitAggregationsSnippet = [];
        if (this._implicitAggregations) {
            implicitAggregationsSnippet = this._implicitAggregations.map(function (agg) {
                var resolver = "aggregation(fields: [" + agg.fields.map(function (f) { return "\"" + f + "\""; }) + "])";
                if (agg.alias) {
                    resolver = agg.alias + ": " + resolver;
                }
                return resolver;
            });
        }
        var createQueryString = function (_a) {
            var operationName = _a.operationName, type = _a.type, dsl = _a.dsl, marketingAttributes = _a.marketingAttributes;
            var marketingAttributesString = '';
            if (marketingAttributes) {
                marketingAttributesString = ("\n          marketing_attributes(\n            attributeTypes: " + marketingAttributes.types + ",\n            attributeClasses: " + marketingAttributes.classes + ",\n            resolveTags: " + marketingAttributes.resolveTags + "\n          ) {\n            ... on ContentMarketingAttribute {\n              " + marketingAttributes.fields + "\n            }\n          }\n        ").trim();
            }
            return ("\n      " + formatted.fragments + "\n      query " + operationName + " {\n        seek(type: " + type + ", dsl: " + dsl + ") {\n          current_page\n          size\n          total_count\n          total_elements\n          total_pages\n          content {\n            ... on " + typeName + " {\n              " + formatted.fields + "\n              " + marketingAttributesString + "\n            }\n          }\n          " + implicitAggregationsSnippet
                .map(function (entry) { return ' '.repeat(4) + entry; })
                .join('\n') + "\n        }\n      }\n    ").trim();
        };
        if (this._marketingAttributes && !this._marketingAttributes.fields) {
            throw new SeekQueryEmptyFieldsError();
        }
        var resultingQuery;
        if (parameterized) {
            var params = __spreadArrays([
                '$type:SeekQueryType!',
                '$dsl:String'
            ], (this._marketingAttributes
                ? [
                    '$resolveTags: Boolean',
                    '$marketingAttributeTypes: [MarketingAttributeType]',
                    '$marketingAttributeClasses: [MarketingAttributeClass]',
                ]
                : []));
            resultingQuery = {
                query: createQueryString(__assign({ operationName: operationName + "(" + params.join(', ') + ")", type: '$type', dsl: '$dsl' }, (this._marketingAttributes
                    ? {
                        marketingAttributes: {
                            resolveTags: '$resolveTags',
                            types: '$marketingAttributeTypes',
                            classes: '$marketingAttributeClasses',
                            fields: this._marketingAttributes.fields.join(' '),
                        },
                    }
                    : {}))),
                variables: __assign({ type: this._kind, dsl: stringifiedDsl }, (this._marketingAttributes
                    ? {
                        marketingAttributeTypes: this._marketingAttributes.types,
                        marketingAttributeClasses: this._marketingAttributes.classes,
                        resolveTags: this._marketingAttributes.resolveTags,
                    }
                    : {})),
            };
        }
        else {
            resultingQuery = createQueryString(__assign({ operationName: operationName, type: this._kind, dsl: escapedDsl }, (this._marketingAttributes
                ? {
                    marketingAttributes: {
                        resolveTags: "" + this._marketingAttributes.resolveTags,
                        types: "[" + this._marketingAttributes.types.join(',') + "]",
                        classes: "[" + this._marketingAttributes.classes.join(',') + "]",
                        fields: this._marketingAttributes.fields.join(' '),
                    },
                }
                : {})));
        }
        return resultingQuery;
    };
    Object.defineProperty(SeekRequest.prototype, "_applicableFields", {
        get: function () {
            return Array.from(this._fields.reduce(function (set, field) {
                var abstractMatch = field.match(/\.on:/);
                return abstractMatch
                    ? set.add(field.slice(0, abstractMatch.index))
                    : set.add(field);
            }, new Set()));
        },
        enumerable: true,
        configurable: true
    });
    return SeekRequest;
}());
var AllQuery = (function () {
    function AllQuery() {
    }
    AllQuery.prototype.toObject = function () {
        return AllQuery.ALL;
    };
    AllQuery.ALL = {
        all: {},
    };
    return AllQuery;
}());
var SeekQuery = (function () {
    function SeekQuery() {
        this.subQuery = new QueryClause();
    }
    SeekQuery.prototype.toObject = function () {
        return this.subQuery.toObject();
    };
    return SeekQuery;
}());
var QueryClause = (function () {
    function QueryClause() {
    }
    QueryClause.prototype.toObject = function () {
        return {};
    };
    return QueryClause;
}());
export { format as formatFieldsToGraphqlQueryFields, SeekTypes as seekTypes, SeekQuery, };
export default SeekRequest;
//# sourceMappingURL=index.js.map